import request from '@/utils/request'

const getStatement = (page, limit) => {
  return request({
    url: '/api/statement',
    method: 'post',
    data: {
      page: page,
      limit: limit
    }
  })
}

const getSlip = (page, limit) => {
  return request({
    url: '/api/statement/slip',
    method: 'post',
    data: {
      page: page,
      limit: limit
    }
  })
}

const getSlipRef = ref => {
  return request({
    url: `/api/statement/slip/reference/${ref}`,
    method: 'get'
  })
}

export default {
  getStatement,
  getSlip,
  getSlipRef
}
